if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };

      this.panel = this.querySelector('[data-panel]');
      this.message = this.querySelector('[data-message]');
      this.successLive = this.querySelector('[data-success-live]');
      this.errorLive = this.querySelector('[data-error-live]');

      document.addEventListener('ajaxProduct:added', () => {
        this.show(this.dataset.success);
      }, options);

      document.addEventListener('ajaxProduct:error', (event) => {
        this.show(event.detail?.errorMessage || this.dataset.error, true);
      }, options);

      this.querySelector('[data-close]').addEventListener('click', () => {
        this.hide();
      }, options);

      this.panel.addEventListener('pointerenter', () => this.pause(), options);
      this.panel.addEventListener('pointerleave', () => this.resume(), options);
      this.panel.addEventListener('focusin', () => this.pause(), options);
      this.panel.addEventListener('focusout', () => {
        queueMicrotask(() => {
          if (this.isConnected) this.resume();
        });
      }, options);

      this.panel.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          this.hide();
        }
      }, options);
    }

    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
      clearTimeout(this.announceTimer);
    }

    normalizeMessage(value) {
      if (typeof value === 'string') return value;
      if (Array.isArray(value)) return value.map((item) => this.normalizeMessage(item)).join(' ');
      if (value && typeof value === 'object') {
        return Object.values(value).map((item) => this.normalizeMessage(item)).join(' ');
      }
      return '';
    }

    show(value, isError = false) {
      const message = this.normalizeMessage(value) || this.dataset.error;

      if (this.panel.hidden) {
        this.returnFocus = document.activeElement;
      }

      clearTimeout(this.timer);
      clearTimeout(this.announceTimer);

      this.message.textContent = message;
      this.querySelector('[data-success-icon]').hidden = isError;
      this.querySelector('[data-error-icon]').hidden = !isError;
      this.panel.hidden = false;

      this.successLive.textContent = '';
      this.errorLive.textContent = '';
      this.announceTimer = setTimeout(() => {
        (isError ? this.errorLive : this.successLive).textContent = message;
      }, 50);

      this.remaining = isError ? 10000 : 5000;
      this.resume();
    }

    pause() {
      if (this.timer) {
        this.remaining = Math.max(0, this.remaining - (Date.now() - this.started));
        clearTimeout(this.timer);
        this.timer = null;
      }
    }

    resume() {
      if (
        this.panel.hidden ||
        this.panel.matches(':hover') ||
        this.panel.contains(document.activeElement) ||
        this.timer
      ) return;

      this.started = Date.now();
      this.timer = setTimeout(() => {
        this.timer = null;
        this.hide();
      }, this.remaining);
    }

    hide() {
      clearTimeout(this.timer);
      clearTimeout(this.announceTimer);
      this.timer = null;

      if (this.panel.contains(document.activeElement) && this.returnFocus?.isConnected) {
        this.returnFocus.focus({ preventScroll: true });
      }

      this.panel.hidden = true;
      this.successLive.textContent = '';
      this.errorLive.textContent = '';
    }
  });
}
